import { useState, useEffect } from "react";
import { useAuth, API } from "@/App";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import { Loader2, Heart, X } from "lucide-react";

export const TestimonialCard = () => {
  const { user, token } = useAuth();
  const [show, setShow] = useState(false);
  const [testo, setTesto] = useState("");
  const [autorizza, setAutorizza] = useState(false);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!token || !["titolare", "amministrativo"].includes(user?.ruolo)) return;
    axios
      .get(`${API}/testimonial/eligibility`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setShow(!!res.data.show))
      .catch(() => {});
  }, [token, user]);

  if (!show) return null;

  const handleSubmit = async () => {
    if (!testo.trim()) {
      toast.error("Scrivi un commento prima di inviare");
      return;
    }
    setSending(true);
    try {
      await axios.post(
        `${API}/testimonial`,
        { testo: testo.trim(), autorizza_pubblicazione: autorizza },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Grazie per la tua testimonianza!");
      setShow(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore nell'invio, riprova");
    } finally {
      setSending(false);
    }
  };

  const handleDismiss = () => {
    setShow(false);
    axios
      .post(`${API}/testimonial/dismiss`, {}, { headers: { Authorization: `Bearer ${token}` } })
      .catch(() => {});
  };

  return (
    <Card className="border-rose-200 bg-rose-50/60" data-testid="testimonial-card">
      <CardContent className="p-5 sm:p-6 relative">
        <button
          onClick={handleDismiss}
          className="absolute top-3 right-3 text-slate-400 hover:text-slate-600 transition-colors"
          aria-label="Chiudi"
          data-testid="testimonial-dismiss-btn"
        >
          <X className="h-5 w-5" />
        </button>
        <div className="flex items-start gap-3">
          <div className="h-9 w-9 rounded-lg bg-rose-100 flex items-center justify-center shrink-0">
            <Heart className="h-5 w-5 text-rose-500" />
          </div>
          <div className="flex-1 min-w-0 space-y-3">
            <div>
              <p className="font-bold text-slate-900">Ci aiuti a crescere?</p>
              <p className="text-sm text-slate-700 mt-1 leading-relaxed">
                "Gestire il tuo team con Ferie &amp; Permessi ti sta facendo risparmiare tempo? Raccontaci in un
                secondo cosa ti piace di più e specifica di dove sei. La tua opinione è fondamentale per noi!"
              </p>
            </div>
            <Textarea
              value={testo}
              onChange={(e) => setTesto(e.target.value)}
              placeholder="Esempio: Ottima per la mia officina a Torino, il calendario condiviso ci ha risolto il caos delle ferie"
              className="bg-white min-h-[80px]"
              data-testid="testimonial-textarea"
            />
            <label className="flex items-start gap-2 text-sm text-slate-700 cursor-pointer">
              <Checkbox
                checked={autorizza}
                onCheckedChange={(v) => setAutorizza(!!v)}
                className="mt-0.5"
                data-testid="testimonial-privacy-checkbox"
              />
              Autorizzo la pubblicazione di questo commento sul sito ufficiale.
            </label>
            <Button
              onClick={handleSubmit}
              disabled={sending}
              className="bg-rose-500 hover:bg-rose-600 text-white"
              data-testid="testimonial-submit-btn"
            >
              {sending ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null}
              Invia
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
